import React, { useMemo } from "react";
import styled from "styled-components";
import PremiumFormField from "../forms/PremiumFormField";
import PremiumHeaderButton from "./PremiumHeaderButton";

// Warehouse-only typography; the shared premium field owns selection/search/portal/chevron.
const Field = styled.div`
    min-width: 0;
    && .Frame48Input, && label[class*="dropdown-label-"] { font-size: 12px; font-style: normal; color: #d1d1d1 !important; }
    .warehouse-error { color: #efbf73; font-size: 12px; }
`;
const EMPTY = [];
export default function PremiumWarehouseSelector({ label = "Destination warehouse", placeholder = "Select warehouse",
    className, warehouses = EMPTY, value = "", disabled = true, loading = false, error, onChange, onRetry }) {
    const options = useMemo(() => warehouses.map(w => ({ value: String(w.id), name: w.name, selected: String(w.id) === value })), [warehouses, value]);
    return <Field className={className}>
        <PremiumFormField type="dropdown" appearance="premium" title={label.replace(/:\s*$/, "") + ":"}
            aria-label={label} interactionState={disabled || loading ? "locked" : "enabled"}
            dropdownData={options} placeholder={placeholder} value={options.find(w => w.selected)?.name || ""}
            isDropdownSearchable isDropdownMultiselect={false} useDropdownPortal disableAssistiveText assistiveTextSpacing={false}
            onDropdownChange={item => { if (!disabled && !loading) onChange?.(item.value); }} />
        {error && <div className="warehouse-error" role="alert">{error}
            {onRetry && <PremiumHeaderButton label="Retry" onClick={onRetry} />}</div>}
    </Field>;
}
